import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import RegistrationType, {
  BSSendRequest,
  CreateBuyer,
  GetBSList,
  GetBSRequestList,
  GetBuyerRequestList,
  GetReferralList,
  GetRegistration,
  GetSellerProfile,
  RequestAcceptReject,
  GetMyBuyerList,
} from "../types/registrationType";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";

interface Action {
  type: string;
  payload?: any;
}

const RegistrationAction = {
  getRegistration:
    (data: GetRegistration): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const registration: any = await axios.post(
          BASE_URL + "registration/get",
          {
            search: data.search,
            limit: data.limit,
            offset: data.offset,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: RegistrationType.SET_REG_LIST,
          payload: registration.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getSellerProfile:
    (data: GetSellerProfile): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const sellerProfile: any = await axios.get(
          BASE_URL + "registration/profile/" + data.id,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }
        );

        dispatch({
          type: RegistrationType.SET_SELLER_PROFILE,
          payload: sellerProfile.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getReferralList:
    (data: GetReferralList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const registration: any = await axios.post(
          BASE_URL + "referral-list",
          {
            search: data.search,
            limit: data.limit,
            offset: data.offset,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        dispatch({
          type: RegistrationType.SET_REFERRAL_LIST,
          payload: {
            data: registration.data.data.data,
            currentPage: registration.data.data.current_page,
            lastPage: registration.data.data.last_page,
            totalData: registration.data.data.total,
            from: registration.data.data.from,
            to: registration.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getBSList:
    (data: GetBSList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "bs/list/",
          {
            userType: data.userType,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: RegistrationType.BS_LIST,
          payload: result.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getBSRequestList:
    (data: GetBSRequestList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const registration: any = await axios.post(
          BASE_URL + "account/bs-list",
          {
            search: data.search,
            limit: data.limit,
            offset: data.offset,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        dispatch({
          type: RegistrationType.SET_BS_REQUESTR_LIST,
          payload: {
            data: registration.data.data.data,
            currentPage: registration.data.data.current_page,
            lastPage: registration.data.data.last_page,
            totalData: registration.data.data.total,
            from: registration.data.data.from,
            to: registration.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  bsSendRequest:
    (data: BSSendRequest): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "account/bs-send-request/",
          {
            id: data.id,
            status: data.status,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: RegistrationType.BS_SEND_REQUEST,
          payload: result.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getBuyerRequestList:
    (data: GetBuyerRequestList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const registration: any = await axios.post(
          BASE_URL + "account/bs-requested-list",
          {
            search: data.search,
            limit: data.limit,
            offset: data.offset,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        dispatch({
          type: RegistrationType.SET_BUYER_REQUESTR_LIST,
          payload: {
            data: registration.data.data.data,
            currentPage: registration.data.data.current_page,
            lastPage: registration.data.data.last_page,
            totalData: registration.data.data.total,
            from: registration.data.data.from,
            to: registration.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  requestAcceptReject:
    (data: RequestAcceptReject): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "account/bs-request-accept-reject/",
          {
            id: data.id,
            status: data.status,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: RegistrationType.BS_REQUEST_ACCEPT_REJECT,
          payload: result.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  createBuyer:
    (data: CreateBuyer): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "account/create-buyer",
          {
            name_of_entity: data.name_of_entity,
            mobile: data.mobile,
            email: data.email,
            password: data.password,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );
        dispatch({
          type: "",
          payload: {
            type: "",
            status: result.data.status,
          },
        });

        return result.data;
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getMyBuyerList:
    (data: GetMyBuyerList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "pos/buyer-list/",
          {
            search: data.search,
            limit: data.limit,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: RegistrationType.MY_BUYER_LISTY,
          payload: result.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default RegistrationAction;
